import LayerAdminService from "./LayerAdminService";

export default class OsmRoadsService extends LayerAdminService {
  public async Force(source: string): Promise<any> {
    return this._client
      .post<any>(`${this._endpoint}/OSM:Roads`, source, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response.data;
      });
  }
  public async Defer(source: string): Promise<any> {
    return this._client
      .post<any>(`${this._endpoint}/OSM:Roads/defer`, source, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response.data;
      });
    }
}
